import { useSatelliteWebRenterWarningsHandler_getUserWarnings } from '@zg-rentals/ts-satellite-client-react-query';
import type { SatelliteWebRenterUserWarningsResponseDto } from '@zg-rentals/ts-satellite-client';
import {
  type UseUserWarningsOptions as SharedUseUserWarningsOptions,
  type UseUserWarningsReturn as SharedUseUserWarningsReturn,
  USER_WARNINGS_QUERY_CONFIG,
  useSharedUserWarnings,
} from '@zg-rentals/satellite-components';

export type UseUserWarningsOptions = SharedUseUserWarningsOptions;

export type UseUserWarningsReturn = SharedUseUserWarningsReturn & {
  isLoading: boolean;
  error: unknown;
  rawData?: SatelliteWebRenterUserWarningsResponseDto;
};

/**
 * Custom hook to fetch and process user warnings data for satellite-rachel-web
 * Combines React Query data fetching with shared processing logic
 * Cache for 1 week since this data rarely changes
 */
export const useUserWarnings = ({
  enablePersonalContactWarning = true,
  enableExternalLinkWarning = true,
}: UseUserWarningsOptions = {}): UseUserWarningsReturn => {
  const {
    data: userWarningsData,
    isLoading,
    error,
  } = useSatelliteWebRenterWarningsHandler_getUserWarnings({
    ...USER_WARNINGS_QUERY_CONFIG,
    enabled: Boolean(enablePersonalContactWarning || enableExternalLinkWarning),
  });

  const {
    personalContactWarningData,
    externalLinkWarningData,
    attachmentSafetySystemMessageData,
    attachmentInterstitialWarningData,
  } = useSharedUserWarnings({
    enablePersonalContactWarning,
    enableExternalLinkWarning,
    userWarningsData,
  });

  return {
    personalContactWarningData,
    externalLinkWarningData,
    attachmentSafetySystemMessageData,
    attachmentInterstitialWarningData,
    isLoading,
    error,
    rawData: userWarningsData,
  };
};
